// Función para hablar el mensaje proporcionado utilizando la API de síntesis de voz del navegador
async function speakMessage(message, Speak) {
      if (Speak) { // Verificar si se puede hablar
        const synthesis = window && (window).speechSynthesis;
  
        // Obtener las voces disponibles
        const getVoices = () => {
          return new Promise(resolve => {
            const voices = synthesis.getVoices();
            if (voices.length) {
              resolve(voices);
            } else {
              synthesis.onvoiceschanged = () => {
                const updatedVoices = synthesis.getVoices();
                resolve(updatedVoices);
              };
            }
          });
        };
  
        // Reproducir el audio
        const playAudio = async () => {
          const voices = await getVoices();
          let voice = voices.find(voice => voice.lang === 'es-ES');
          
          if (!voice) {
            voice = voices.find(voice => voice.lang === 'en-US');
          }

          if (voice) {
            const utterance = new SpeechSynthesisUtterance(message);
            utterance.voice = voice;
            try {
              synthesis.speak(utterance);
            } catch (error) {
              console.log('Speaking...');
            }
          } else {
            console.error('Voz no encontrada.');
          }
        };
  
        await playAudio();
      }
  }
  
  // Función para detener la síntesis de voz en curso
  function stopSpeaking() {
    if ('speechSynthesis' in window && window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
  }
  
  // Función para habilitar o deshabilitar la síntesis de voz
  function toggleSpeaking(bool) {
    if ('speechSynthesis' in window) {
      if (bool) {
        stopSpeaking();
        return false; // Deshabilitar la síntesis de voz
      } else {
        return true; // Habilitar la síntesis de voz
      }
    }
  }
  
  export { speakMessage, stopSpeaking, toggleSpeaking };